import { render, staticRenderFns } from "./usuarios-formulario.vue?vue&type=template&id=4850fce1&scoped=true&"
import script from "./usuarios-formulario.vue?vue&type=script&lang=js&"
export * from "./usuarios-formulario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4850fce1",
  null
  
)

export default component.exports